module.exports = __webpack_public_path__ + "static/WEDDING E&M-435-f6c42140dddf5e372f5f3a6c7624d378.jpg";